import type {
  CommonResponseSliceSmsTemplate,
  CommonResponseSmsDto,
  CommonResponseSmsTemplateSample,
  SmsTemplateResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent, type Slice, sliceSchema } from '~/schema/slice'

import {
  type SmsHistory,
  SmsHistorySchema,
  type SmsTemplate,
  SmsTemplateSampleSchema,
  SmsTemplateSchema,
} from './schemas'

const ENTITY = 'Sms'

// 생성 타입과 실제 와이어가 어긋나는 필드:
//   SmsTemplate.templateSendingType — 생성 타입은 optional(키 생략)로 그리지만 서버는 키를 빼지 않고 null 을 싣는다
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 sms/model/dto/SmsTemplate.kt·controller/response/SmsTemplateResponse.kt 로 확인.
const asWire = (raw: unknown): unknown => raw

export const adaptSmsHistory = (raw: CommonResponseSmsDto['data']): SmsHistory => {
  const history = parseApiResponse(SmsHistorySchema, raw, ENTITY)
  return { summary: history.summary, page: mapSliceContent(history.page, (sms) => sms) }
}

export const adaptSmsTemplates = (
  raw: CommonResponseSliceSmsTemplate['data'],
): Slice<SmsTemplate> =>
  mapSliceContent(
    parseApiResponse(sliceSchema(SmsTemplateSchema), asWire(raw), ENTITY),
    (template) => template,
  )

export const adaptSmsTemplate = (raw: SmsTemplateResponse): SmsTemplate =>
  parseApiResponse(SmsTemplateSchema, asWire(raw), ENTITY)

export const adaptSmsTemplateSampleMessage = (
  raw: CommonResponseSmsTemplateSample['data'],
): string => parseApiResponse(SmsTemplateSampleSchema, raw, ENTITY).messages
